export const COMMENT_NUM_PER_PAGE = 20;

export const COMMENT_INITIAL_PAGER_SEARCH_PARAMS = {
  start: 1,
  limit: COMMENT_NUM_PER_PAGE,
};

export const COMMENT_SEARCH_STORED_KEY = "commentSearchCondition";
